import $ from "../core/jquery-global";
import Swiper from "swiper/bundle";
import "swiper/css/bundle";
import fotogalleryItems from "../data/fotogallery-items";

export function initSliders() {
    var sliderInstances = {};
    var resizeTimer = null;

    function escapeHtml(value) {
        return String(value || "")
            .replace(/&/g, "&amp;")
            .replace(/"/g, "&quot;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;");
    }

    /* function buildHomeFotogallerySlider() {
        var $slider = $("#slider-home-fotogallery");

        if (!$slider.length) {
            return;
        }

        var $wrapper = $slider.find(".swiper-wrapper");

        if (!$wrapper.length || $wrapper.children().length) {
            return;
        }

        var slidesHtml = "";

        fotogalleryItems.forEach(function (item, index) {
            var isVideo = item.type === "embed";
            var mediaSrc = item.type === "image" ? item.full || "" : item.embedUrl || "";
            var mediaAlt = item.alt || item.title || "";
            var buttonLabel = isVideo ? "Apri video " + (index + 1) : "Apri immagine " + (index + 1);

            var iconHtml = isVideo
                ? `
        <span class="fotogallery-icon fotogallery-icon--video" aria-hidden="true">
            <svg viewBox="0 0 24 24">
                <path d="M8 5v14l11-7z" fill="currentColor"></path>
            </svg>
        </span>
    `
                : `
        <span class="fotogallery-icon fotogallery-icon--image" aria-hidden="true">
            <svg viewBox="0 0 24 24">
                <path d="M4 7h4l2-2h4l2 2h4v12H4z" fill="none" stroke="currentColor" stroke-width="2"/>
                <circle cx="12" cy="13" r="4" fill="none" stroke="currentColor" stroke-width="2"/>
            </svg>
        </span>
    `;

            slidesHtml += `
                <div class="slider-item swiper-slide">
                    <button
                        type="button"
                        class="media-wrapper media-wrapper-image image-wrapper js_openFotogalleryOverlay"
                        data-type="${escapeHtml(item.type)}"
                        data-src="${escapeHtml(mediaSrc)}"
                        data-alt="${escapeHtml(mediaAlt)}"
                        aria-label="${escapeHtml(buttonLabel)}"
                    >
                        <picture>
                            <img
                                src="${escapeHtml(item.thumb)}"
                                loading="lazy"
                                alt="${escapeHtml(mediaAlt)}"
                                sizes="20vw"
                                class="image"
                            >
                        </picture>
                        ${iconHtml}
                    </button>

                    ${
                        item.title
                            ? `<div class="text-wrapper">${
                                  item.where ? `<span class="shortinfo">${escapeHtml(item.where)}</span>` : ""
                              }<h5 class="title">${escapeHtml(item.title)}</h5></div>`
                            : ""
                    }
                    <div class="swiper-lazy-preloader"></div>
                </div>
            `;
        });

        $wrapper.html(slidesHtml);
    } */



        function buildHomeFotogallerySlider() {
    var $slider = $("#slider-home-fotogallery");

    if (!$slider.length) {
        return;
    }

    var $wrapper = $slider.find(".swiper-wrapper");

    if (!$wrapper.length || $wrapper.children().length) {
        return;
    }

    var slidesHtml = "";

    fotogalleryItems.forEach(function (item, index) {
        if (!item) return;

        var isVideo = item.type === "embed";
        var isUrl   = item.type === "url";
        var mediaSrc = item.type === "image" ? item.full || "" : item.embedUrl || "";
        var mediaAlt = item.alt || item.title || "";

        var buttonLabel = isVideo
            ? "Apri video " + (index + 1)
            : isUrl
                ? "Apri link " + (index + 1)
                : "Apri immagine " + (index + 1);

        var iconHtml = isVideo
            ? `<span class="fotogallery-icon fotogallery-icon--video" aria-hidden="true">
                   <svg viewBox="0 0 24 24">
                       <path d="M8 5v14l11-7z" fill="currentColor"></path>
                   </svg>
               </span>`
            : isUrl
                ? `<span class="fotogallery-icon fotogallery-icon--url" aria-hidden="true">
                       <svg viewBox="0 0 24 24">
                           <path d="M14 3h7v7h-2V6.41l-9.29 9.3-1.42-1.42L17.59 5H14V3zm-1 2H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8h-2v8H5V7h8V5z" fill="currentColor"/>
                       </svg>
                   </span>`
                : `<span class="fotogallery-icon fotogallery-icon--image" aria-hidden="true">
                       <svg viewBox="0 0 24 24">
                           <path d="M4 7h4l2-2h4l2 2h4v12H4z" fill="none" stroke="currentColor" stroke-width="2"/>
                           <circle cx="12" cy="13" r="4" fill="none" stroke="currentColor" stroke-width="2"/>
                       </svg>
                   </span>`;

        var mediaWrapperHtml;

        if (isUrl) {
            var a = document.createElement("a");
            a.href = item.url;
            a.target = "_blank";
            a.rel = "noopener noreferrer";
            a.className = "media-wrapper media-wrapper-image image-wrapper";
            a.setAttribute("aria-label", buttonLabel);
            a.innerHTML = `
                <picture>
                    <img src="${escapeHtml(item.thumb)}" loading="lazy" alt="${escapeHtml(mediaAlt)}" sizes="20vw" class="image">
                </picture>
                ${iconHtml}
            `;
            mediaWrapperHtml = a.outerHTML;
        } else {
            mediaWrapperHtml = `<button
                type="button"
                class="media-wrapper media-wrapper-image image-wrapper js_openFotogalleryOverlay"
                data-type="${escapeHtml(item.type)}"
                data-src="${escapeHtml(mediaSrc)}"
                data-alt="${escapeHtml(mediaAlt)}"
                aria-label="${escapeHtml(buttonLabel)}"
            >
                <picture>
                    <img src="${escapeHtml(item.thumb)}" loading="lazy" alt="${escapeHtml(mediaAlt)}" sizes="20vw" class="image">
                </picture>
                ${iconHtml}
            </button>`;
        }

        var textWrapperHtml = item.title
            ? `<div class="text-wrapper">
                   ${item.where ? `<span class="shortinfo">${escapeHtml(item.where)}</span>` : ""}
                   <h5 class="title">${escapeHtml(item.title)}</h5>
               </div>`
            : "";

        slidesHtml += `
            <div class="slider-item swiper-slide">
                ${mediaWrapperHtml}
                ${textWrapperHtml}
                <div class="swiper-lazy-preloader"></div>
            </div>
        `;
    });

    $wrapper.html(slidesHtml);
}
    function createOverlayEmbedIframe($overlay, src, title) {
        var $embedWrap = $overlay.find(".fotogallery-overlay__embed");

        if (!$embedWrap.length) {
            return null;
        }

        $embedWrap.empty();

        var $iframe = $(`
            <iframe
                class="fotogallery-overlay__iframe"
                src="${escapeHtml(src || "")}"
                title="${escapeHtml(title || "Video embed")}"
                loading="lazy"
                allow="autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
                referrerpolicy="strict-origin-when-cross-origin">
            </iframe>
        `);

        $embedWrap.append($iframe);

        return $iframe;
    }

    function resetFotogalleryOverlayMedia() {
        var $overlay = $("#fotogallery-overlay");
        var $image = $overlay.find(".fotogallery-overlay__image");
        var $embedWrap = $overlay.find(".fotogallery-overlay__embed");

        $image.attr("src", "").attr("alt", "").hide();
        $embedWrap.hide().empty();
    }

    function stopFotogallerySwiper() {
        var fotogallerySwiper = sliderInstances["slider-home-fotogallery"];

        if (!fotogallerySwiper) {
            return;
        }

        if (fotogallerySwiper.autoplay && typeof fotogallerySwiper.autoplay.stop === "function") {
            fotogallerySwiper.autoplay.stop();
        }

        if (typeof fotogallerySwiper.disable === "function") {
            fotogallerySwiper.disable();
        }
    }

    function resumeFotogallerySwiper() {
        var fotogallerySwiper = sliderInstances["slider-home-fotogallery"];

        if (!fotogallerySwiper) {
            return;
        }

        if (typeof fotogallerySwiper.enable === "function") {
            fotogallerySwiper.enable();
        }

        if (fotogallerySwiper.autoplay && typeof fotogallerySwiper.autoplay.start === "function") {
            fotogallerySwiper.autoplay.start();
        }
    }

    function openFotogalleryOverlay(type, src, alt) {
        var $overlay = $("#fotogallery-overlay");
        var $image = $overlay.find(".fotogallery-overlay__image");
        var $embedWrap = $overlay.find(".fotogallery-overlay__embed");

        if (!$overlay.length) {
            return;
        }

        resetFotogalleryOverlayMedia();
        stopFotogallerySwiper();

        $overlay.addClass("is_open").attr("aria-hidden", "false");
        $("body").addClass("is_overlay_open");

        if (type === "embed") {
            if (!src) {
                return;
            }

            createOverlayEmbedIframe($overlay, src, alt || "Video embed");
            $embedWrap.show();
            return;
        }

        if (!src) {
            return;
        }

        $image.attr("src", src).attr("alt", alt || "").show();
    }

    function closeFotogalleryOverlay() {
        var $overlay = $("#fotogallery-overlay");

        if (!$overlay.length || !$overlay.hasClass("is_open")) {
            return;
        }

        resetFotogalleryOverlayMedia();
        $overlay.removeClass("is_open").attr("aria-hidden", "true");
        $("body").removeClass("is_overlay_open");
        resumeFotogallerySwiper();
         $(".slider-button-prev, .slider-button-next").removeClass("swiper-button-lock");

    }

    function getSliderOptions($slider) {
        var $scope = $slider.closest(".slider-wrapper-container").length
            ? $slider.closest(".slider-wrapper-container")
            : $slider.closest(".section");

        var prevEl = $scope.find(".slider-button-prev").get(0);
        var nextEl = $scope.find(".slider-button-next").get(0);

        var isInsights = $slider.hasClass("slider-insights");
        var ww = $(window).outerWidth();

        var options = {
            loop: true,
            speed: 400,
            autoplay: false,
            navigation: {
                prevEl: prevEl,
                nextEl: nextEl
            },
            slidesPerView: 4,
            spaceBetween: 40,
            watchOverflow: true,
            watchSlidesProgress: true,
            breakpoints: {
                0: { slidesPerView: 1 },
                650: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
                1400: { slidesPerView: 4 }
            }
        };

        if (isInsights) {
            if (ww <= 650) {
                options.slidesPerView = 1;
            } else if (ww <= 1024) {
                options.slidesPerView = 2;
            } else {
                options.slidesPerView = 4;
            }
        } else {
            options.slidesPerView = 1;
        }

        return options;
    }

    /* function initSlider($slider) {
        var id = $slider.attr("id");

        if (!id) {
            return;
        }

        if (sliderInstances[id]) {
            sliderInstances[id].destroy(true, true);
            delete sliderInstances[id];
        }

        var options = getSliderOptions($slider);
        var instance = new Swiper("#" + id, options);

        setupAutoplayOnView(instance);

        sliderInstances[id] = instance;

        handleInsightsState($slider, instance);

        instance.on("slideChange", function () {
            handleInsightsState($slider, instance);
        });

        instance.on("transitionEnd", function () {
            handleInsightsState($slider, instance);
        });

        instance.on("setTranslate", function () {
            handleInsightsState($slider, instance);
        });

        instance.on("resize", function () {
            handleInsightsState($slider, instance);
        });

        instance.on("breakpoint", function () {
            handleInsightsState($slider, instance);
        });
    } */

function initSlider($slider) {
    var id = $slider.attr("id");

    if (!id) {
        return;
    }

    if (sliderInstances[id]) {
        sliderInstances[id].destroy(true, true);
        delete sliderInstances[id];
    }

    var options = getSliderOptions($slider);

    var instance = new Swiper("#" + id, {
        ...options,
        loop: true,
        allowTouchMove: true,
        watchOverflow: false
    });

    if (instance.params.navigation && instance.navigation) {
        instance.navigation.destroy();

        instance.params.navigation.prevEl = options.navigation.prevEl;
        instance.params.navigation.nextEl = options.navigation.nextEl;

        instance.navigation.init();
        instance.navigation.update();
    }

    if (instance.params.loop) {
        instance.loopDestroy();
        instance.loopCreate();
    }

    instance.update();

    setupAutoplayOnView(instance);

    sliderInstances[id] = instance;

    handleInsightsState($slider, instance);

    instance.on("slideChange", function () {
        handleInsightsState($slider, instance);
    });

    instance.on("transitionEnd", function () {
        handleInsightsState($slider, instance);
    });

    instance.on("setTranslate", function () {
        handleInsightsState($slider, instance);
    });

    instance.on("resize", function () {
        handleInsightsState($slider, instance);
    });

    instance.on("breakpoint", function () {
        handleInsightsState($slider, instance);
    });
}


    function setupAutoplayOnView(swiper) {
        var hasStarted = false;
        var timeoutId = null;

        var observer = new IntersectionObserver(
            function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        if (!hasStarted) {
                            hasStarted = true;

                            timeoutId = setTimeout(function () {
                                if (swiper && swiper.autoplay) {
                                    swiper.params.autoplay = {
                                        delay: 5000,
                                        disableOnInteraction: false
                                    };
                                    swiper.autoplay.start();
                                }
                            }, 5000);
                        }
                    } else {
                        if (swiper && swiper.autoplay) {
                            swiper.autoplay.stop();
                        }

                        if (timeoutId) {
                            clearTimeout(timeoutId);
                            timeoutId = null;
                            hasStarted = false;
                        }
                    }
                });
            },
            { threshold: 0.5 }
        );

        observer.observe(swiper.el);
    }

    function handleInsightsState($slider, swiper) {
        if (!$slider.hasClass("slider-insights")) {
            return;
        }

        var containerRect = swiper.el.getBoundingClientRect();

        $slider.find(".swiper-slide").removeClass("is_current_insight_group");

        $(swiper.slides).each(function () {
            var slide = this;
            var slideRect = slide.getBoundingClientRect();

            var fullyVisible =
                slideRect.left >= containerRect.left && slideRect.right <= containerRect.right;

            if (fullyVisible) {
                $(slide).addClass("is_current_insight_group");
            }
        });
var totalRealSlides = swiper.slides
    ? Array.from(swiper.slides).filter(function (slide) {
          return !slide.classList.contains("swiper-slide-duplicate");
      }).length
    : 0;

var currentSlidesPerView = swiper.params.slidesPerView;

if (swiper.currentBreakpoint && swiper.params.breakpoints && swiper.params.breakpoints[swiper.currentBreakpoint]) {
    currentSlidesPerView = swiper.params.breakpoints[swiper.currentBreakpoint].slidesPerView;
}

if (currentSlidesPerView === "auto") {
    currentSlidesPerView = 1;
}

currentSlidesPerView = Number(currentSlidesPerView) || 1;

var $scope = $slider.closest(".slider-wrapper-container").length
    ? $slider.closest(".slider-wrapper-container")
    : $slider.closest(".section");

var $buttonsWrap = $scope.find(".slider-buttons");

if ($buttonsWrap.length) {
    if (totalRealSlides <= currentSlidesPerView) {
        $buttonsWrap.addClass("is_hidden");
    } else {
        $buttonsWrap.removeClass("is_hidden");
    }
}
    }

    function initAllSliders() {
        $(".slider.swiper").each(function () {
            initSlider($(this));
        });
    }

    $(window).on("resize", function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            initAllSliders();
        }, 200);
    });

    $(document).on("click", ".js_openFotogalleryOverlay", function () {
        var type = $(this).attr("data-type") || "";
        var src = $(this).attr("data-src") || "";
        var alt = $(this).attr("data-alt") || "";

        openFotogalleryOverlay(type, src, alt);
    });

    $(document).on("click", ".js_closeFotogalleryOverlay", function () {
        closeFotogalleryOverlay();
    });

    $(document).on("click", ".fotogallery-overlay__dialog", function (e) {
        if (
            $(e.target)
                .closest(
                    ".fotogallery-overlay__image, .fotogallery-overlay__embed, .fotogallery-overlay__close"
                )
                .length
        ) {
            return;
        }

        closeFotogalleryOverlay();
    });

    $(document).on("keydown", function (e) {
        if (e.key === "Escape") {
            closeFotogalleryOverlay();
        }
    });

    buildHomeFotogallerySlider();
    initAllSliders();
}
